import { defineMessages } from 'react-intl';

const messages = defineMessages({
  floorPlanGrossSqFt: {
    id: 'App.ViewUnit.UnitSqFtInformation.FloorPlanGrossSqFt',
    defaultMessage: 'Floor Plan Gross SqFt',
  },
  unitRentableSqFt: {
    id: 'App.ViewUnit.UnitSqFtInformation.UnitRentableSqFt',
    defaultMessage: 'Unit Rentable SqFt',
  },
  unitUsableSqFt: {
    id: 'App.ViewUnit.UnitSqFtInformation.UnitUsableSqFt',
    defaultMessage: 'Unit Usable SqFt',
  },
});

export default messages;
